module.exports = __webpack_public_path__ + "static/media/ic_chevron_right.c38f61c2.svg";